"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const AbiertoIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== 'auto') {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== 'auto') {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "22 0 150 199" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M162.782,80.785c-5.791-5.542-14.035-8.356-24.509-8.356h-76V45.742c0-19.152,16.5-34.731,36.787-34.731h1.88 c20.287,0,36.787,15.579,36.787,34.731c0,2.901,2.354,5.255,5.255,5.255s5.255-2.354,5.255-5.255 c0-24.943-21.221-45.242-47.297-45.242h-1.88c-26.077,0-47.297,20.299-47.297,45.242v27.633c-5.977,1.233-10.921,3.724-14.757,7.422 c-5.99,5.778-9.028,14.235-9.028,25.156c0,0.124,0,0.249,0.013,0.373c0,0.237,0.012,0.859,0.025,2.354l-0.038,57.296 c0,10.921,3.038,19.389,9.028,25.155c5.753,5.555,13.998,8.368,24.483,8.368h76.785c10.474,0,18.718-2.802,24.509-8.355 c6.001-5.754,9.103-14.197,9.24-25.094v-60.16C171.885,94.982,168.783,86.538,162.782,80.785z M161.512,165.951 c-0.2,15.716-7.584,23.038-23.238,23.038H61.489c-15.691,0-23.001-7.31-23.001-23l0.038-57.322v-0.036 c-0.013-1.259-0.013-1.956-0.025-2.343v-0.447c0-0.037-0.013-0.062-0.013-0.1c0.062-15.555,7.385-22.802,23.001-22.802h76.785 c15.654,0,23.038,7.323,23.238,23.038V165.951z" }))));
};
exports.default = AbiertoIconM;
//# sourceMappingURL=index.js.map